// extracted by mini-css-extract-plugin
module.exports = {"logos":"styles_logos__vWLyO","logo_ext":"styles_logo_ext__1MF3y","logo":"styles_logo__2TSO3","mainLogo":"styles_mainLogo__BKTJ1"};